import styled, { keyframes } from 'styled-components'
import IMAGES from '../../images'

export const GreenBackgroundWrapper = styled.div`
  padding: 16px 0;
  background: url(${props => props.backgroundImage}) top center no-repeat;
  background-size: cover;

  .leftCol {
    display: flex;
    justify-content: start;
    align-items: center;
    @media only screen and (max-width: 992px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .rightCol {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 24px 0;
  }
`
export const GreenBackgroundImg = styled.div`
  background: url(${IMAGES.CIRCLE_STATION}) center center no-repeat;
  background-size: cover;
  width: 620px;
  height: 470px;
  padding-top: 86px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 1200px) {
    width: 320px;
    height: 282px;
    padding-top: 37px;
  }
`
export const VpFlower = styled.img`
  width: 56px;
  height: 48px;
  transition: all 1s;
  @media only screen and (max-width: 1200px) {
    transform: scale(0.6);
  }
`
export const FlowerText = styled.img`
  width: auto;
  height: 130px;
  margin-top: 4px;
  @media only screen and (max-width: 1200px) {
    width: auto;
    height: 80px;
  }
  @media only screen and (max-width: 992px) {
    width: auto;
    height: 80px;
  }
  @media only screen and (max-width: 768px) {
    width: auto;
    height: 80px;
  }
  @media only screen and (max-width: 576px) {
    width: auto;
    height: 70px;
  }
`
export const GreenStationImageLeft = styled.img`
  @media only screen and (max-width: 1600px) {
    width: 90%;
    height: auto;
    padding: 0 16px;
  }
`
export const GreenStationImageRight = styled.img`
  width: 90%;
  @media only screen and (max-width: 1200px) {
    width: 90%;
    height: auto;
    padding: 0 16px;
  }
  @media only screen and (max-width: 576px) {
    width: 90%;
    height: auto;
    padding: 0 16px;
  }
`
export const GreenBackgroundText = styled.div`
  font-weight: 500;
  font-size: 18px;
  color: #fff;
  text-align: justify;
  margin-top: 24px;
  @media only screen and (max-width: 1600px) {
    padding: 0 16px;
    width: auto;
    font-size: 16px;
  }
`
